(() => {
  if (window.barewayShippingLocalization) return;
  window.barewayShippingLocalization = true;
  const selector = '.bw-ref-shipping, .bw-purchase-shipping-country';
  const source = document.querySelector('[data-bw-shipping-context]');
  if (!source || !document.querySelector(selector)) return;
  let context;
  try { context = JSON.parse(source.textContent); } catch { return; }
  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(link => {
    const iso = link.hreflang;
    if (!iso || iso === 'x-default' || context.languages.some(language => language.iso.toLowerCase() === iso.toLowerCase())) return;
    const target = new URL(link.href, location.origin);
    if (target.origin === location.origin) context.languages.push({iso, root:target.pathname, primary:false});
  });
  const preferenceKey = 'bareway-shipping-preference';
  const baseLanguage = code => String(code || '').toLowerCase().split('-')[0];
  const matchLanguage = code => context.languages.find(l => l.iso.toLowerCase() === String(code).toLowerCase()) || context.languages.find(l => baseLanguage(l.iso) === baseLanguage(code));
  let preference = {};
  try { preference = JSON.parse(sessionStorage.getItem(preferenceKey) || '{}'); } catch {}
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !new URL(form.action, location.origin).pathname.endsWith('/localization')) return;
    const fields = new FormData(form);
    const country = fields.get('country_code');
    const language = fields.get('language_code');
    try { sessionStorage.setItem(preferenceKey, JSON.stringify({country: country || preference.country, language: language || preference.language})); } catch {}
  }, true);
  const request = async url => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 4000);
    try {
      const response = await fetch(url, {credentials:'same-origin', signal:controller.signal});
      if (!response.ok) throw new Error('Unavailable');
      return await response.text();
    } finally { clearTimeout(timer); }
  };
  const chooseLanguage = () => matchLanguage(context.locale);
  const textFor = (data, country) => {
    const index = data.codes.indexOf(country);
    if (index < 0) return null;
    let name = data.names[index];
    let prefix = data.prefix;
    const language = baseLanguage(data.locale);
    if (language === 'en' && ['GB','US','NL','AE','PH','BS','MV','SC'].includes(country)) name = 'the ' + name;
    if (language === 'pt') {
      if (['BR','GB','CA','JP','MX'].includes(country)) name = 'o ' + name;
      if (['CH','DE','FR','IT','ES','AU','AR'].includes(country)) name = 'a ' + name;
      if (['US','NL','AE'].includes(country)) name = 'os ' + name;
    }
    if (language === 'de') {
      if (['CH','TR'].includes(country)) prefix = prefix.replace(/ nach$/, ' in die');
      if (['GB'].includes(country)) prefix = prefix.replace(/ nach$/, ' in das');
      if (['US','NL','AE','PH','BS','MV','SC'].includes(country)) prefix = prefix.replace(/ nach$/, ' in die');
    }
    return {prefix, name};
  };
  const render = (data, country) => {
    const wording = textFor(data, country);
    if (!wording) return;
    document.querySelectorAll(selector).forEach(row => {
      const text = document.createElement('span');
      const name = document.createElement('strong');
      name.textContent = wording.name;
      text.append(document.createTextNode(wording.prefix + ' '), name);
      if (row.matches('.bw-ref-shipping')) {
        const flag = document.createElement('img');
        flag.src = 'https://cdn.shopify.com/static/images/flags/' + country.toLowerCase() + '.svg?width=24';
        flag.width = 16;
        flag.height = 12;
        flag.alt = '';
        const separator = document.createElement('span');
        separator.setAttribute('aria-hidden', 'true');
        separator.textContent = '|';
        row.replaceChildren(flag, separator, text);
      } else {
        const oldText = row.querySelector('span');
        if (oldText) oldText.replaceWith(text);
      }
      row.dataset.country = country;
      row.dataset.bwShippingCountry = country;
      row.dataset.bwShippingEligible = 'true';
      row.lang = data.locale;
    });
  };
  const start = async () => {
    let country = context.codes.includes(preference.country) ? preference.country : context.country;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const url = new URL(root + 'browsing_context_suggestions.json', location.origin);
      url.searchParams.set('country[enabled]', 'true');
      url.searchParams.set('language[enabled]', 'true');
      const detected = JSON.parse(await request(url));
      const parts = detected.suggestions?.[0]?.parts || {};
      const detectedCountry = preference.country || detected.detected_values?.country?.handle || parts.country?.handle || context.country;
      if (!/^[A-Z]{2}$/.test(detectedCountry)) return;
      if (!context.codes.includes(detectedCountry)) {
        document.querySelectorAll(selector).forEach(row => {
          const fallback = document.createElement('span');
          fallback.textContent = context.fallback;
          if (row.matches('.bw-ref-shipping')) row.replaceChildren(fallback);
          else row.querySelector('span')?.replaceWith(fallback);
          row.dataset.country = detectedCountry;
          row.dataset.bwShippingCountry = detectedCountry;
          row.dataset.bwShippingEligible = 'false';
        });
        return;
      }
      country = detectedCountry;
      const language = chooseLanguage(country, parts.language?.handle);
      let localized = context;
      if (language && language.iso.toLowerCase() !== context.locale.toLowerCase()) {
        const endpoint = new URL(language.root, location.origin);
        if (endpoint.origin !== location.origin) return;
        endpoint.searchParams.set('section_id', 'bareway-shipping-localization');
        const html = new DOMParser().parseFromString(await request(endpoint), 'text/html');
        const data = html.querySelector('[data-bw-shipping-context]');
        if (!data) throw new Error('Missing translation');
        localized = JSON.parse(data.textContent);
        if (localized.locale.toLowerCase() !== language.iso.toLowerCase()) throw new Error('Language mismatch');
      }
      render(localized, country);
    } catch {
      render(context, country);
    }
  };
  start();
  document.addEventListener('shopify:section:load', start);
})();

